import { db, functions } from '@/firebase'

export default {
    getGroups({ commit }) {
        var g = functions.httpsCallable('httpVromoGetGroups');
        return g()
            .then(r => {
                commit('setGroups', r.data)
            })
    },
    getHooks({ commit }) {
        var h = functions.httpsCallable('httpVromoGetGroups');
        return g()
    },
    createHook({ commit }, idnegocio) {
        var h = functions.httpsCallable('httpVromoCrearHook');
        return h(idnegocio).then(r => r.data)
    },
    getHooks({ commit }, idnegocio) {
        var h = functions.httpsCallable('httpVromoGetHooks');
        return h(idnegocio).then(r => r.data)
    },
    deleteHook({ commit }, payload) {
        var h = functions.httpsCallable('httpVromoDeleteHook');
        return h(payload).then(r => r.data)
    },
}